import { render, staticRenderFns } from "./MetricsChartsByProject.vue?vue&type=template&id=01835235"
import script from "./MetricsChartsByProject.vue?vue&type=script&lang=js"
export * from "./MetricsChartsByProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports